import styled from '@emotion/styled';

import FormItem from 'components/form/FormItem';

export const GroupSeperator = styled.div`
	border-top: 1px solid var(--black-30);
	border-left: 1px solid var(--black-30);
	border-bottom: 1px solid var(--black-30);
	width: 2rem;
`;

export const TableFormItem = styled(FormItem)`
	.form-item-content {
		flex-direction: row;
		gap: 1.5rem;
	}
`;
